import { createRoot } from 'react-dom/client';
import 'simplebar/dist/simplebar.css';
import 'assets/third-party/apex-chart.css';
import 'assets/third-party/react-table.css';

import React from 'react';
import AppProviders from 'contexts';
import App from './App';
import 'styles/custom.css';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { ApplicationProvider } from './contexts/AppContext';
import { DialingCodesProvider } from 'contexts/DialingCodesContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <DialingCodesProvider>
        <AuthProvider>
            <ApplicationProvider>
                <AppProviders>
                    <App />
                </AppProviders>
            </ApplicationProvider>
        </AuthProvider>
    </DialingCodesProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
